import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { TestResult, testResultSchema } from '@sophocles/entities/TestResult/testResultRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_TEST_RESULTS = 'RECEIVE_TEST_RESULTS';
function receiveTestResults(json) {
  return {
    type: RECEIVE_TEST_RESULTS,
    testResults: mapListToRecords(json, TestResult),
  };
}

/* Request Actions */
// starter request
export const REQUEST_TEST_RESULT = 'REQUEST_TEST_RESULT';
function requestTestResult(testResult_id) {
  return {
    type: REQUEST_TEST_RESULT,
    testResult_id,
  };
}

export const REQUEST_ALL_TEST_RESULTS = 'REQUEST_ALL_TEST_RESULTS';
function requestAllTestResults() {
  return {
    type: REQUEST_ALL_TEST_RESULTS,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchTestResult(testResult_id) {
  return dispatch => {
    dispatch(requestTestResult(testResult_id));
    return apiClient
      .get(`/testresults/${testResult_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'testResults', testResultSchema))
      .then(json => dispatch(receiveTestResults(json.entities.testResults)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_TEST_RESULT)));
  };
}

export function fetchAllTestResults() {
  return dispatch => {
    dispatch(requestAllTestResults());
    return apiClient
      .get(`/testresults/?limit=10000`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'testResults', testResultSchema))
      .then(json => dispatch(receiveTestResults(json.entities.testResults)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_TEST_RESULT)));
  };
}

/* Edit Actions */
export const EDIT_TEST_RESULT = 'EDIT_TEST_RESULT';
export function editTestResult(testResult_id) {
  return {
    type: EDIT_TEST_RESULT,
    testResult: testResult_id,
  };
}

export function patchTestResult(testResult_id, values) {
  return dispatch => {
    dispatch(editTestResult(testResult_id));
    return apiClient
      .patch(`/testresults/${testResult_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, testResultSchema))
      .then(json => dispatch(receiveTestResults(json.entities.testResults)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_TEST_RESULT)));
  };
}

/* Create Actions */
export const CREATE_TEST_RESULT = 'CREATE_TEST_RESULT';
function sayCreateTestResult(values) {
  return {
    type: CREATE_TEST_RESULT,
    values: values,
  };
}

export function createTestResult(values) {
  return dispatch => {
    dispatch(sayCreateTestResult(values));
    return apiClient
      .post(`/testresults/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, testResultSchema))
      .then(json => dispatch(receiveTestResults(json.entities.testResults)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_TEST_RESULT)));
  };
}

/* Delete Actions */
export const DELETE_TEST_RESULT = 'DELETE_TEST_RESULT';
function sayDeleteTestResult(testResult_id) {
  return {
    type: DELETE_TEST_RESULT,
    testResult: testResult_id,
  };
}

export function deleteTestResult(testResult_id) {
  return dispatch =>
    apiClient
      .delete(`/testresults/${testResult_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteTestResult(testResult_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_TEST_RESULT)));
}
